import React, { useCallback, useState } from "react";
import { ILocationsProps } from "./LocationsContextInterfaces";
import { LocationsContext, initialState } from "./LocationsContext";

export const LocationsProvider: React.FC<ILocationsProps> = ({ children }) => {
    const [millTimezone, setMillTimezone] = useState<string | undefined>(initialState.millTimezone);

    const handleMillTimezone = useCallback((value: string | undefined) => {
        setMillTimezone(value);
    }, []);

    const providerValue = {
        millTimezone,
        handleMillTimezone,
    };

    return <LocationsContext.Provider value={providerValue}>{children}</LocationsContext.Provider>;
};
